<template>
    <div class="swiper-container">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in list" :key="item.itemid">
                    <div class="img-wrapper">
                        <img :src="item | rewardIconFilter" alt=""/>
                    </div>
                    <h4>{{item | rewardNameFilter}}×{{item.counts}}</h4>
                </div>
            </div>
        </div>
        <div class="btn btn-prev"></div>
        <div class="btn btn-next"></div>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
export default {
    name: 'MySwiper',
    props:['list'],
    mounted() {
        new Swiper('.swiper', {
            modules: [Navigation],
            slidesPerView: 3,
            navigation: {
                nextEl: ".btn-next",
                prevEl: ".btn-prev"
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    width: 5.82rem;
    margin: 0rem auto;
    position: relative;
    text-align: center;
    img{
        width: 0.8rem;
        vertical-align: middle;
    }
    h4{
        font-weight: normal;
        margin-top: 0.12rem;
    }
}
.btn{
    position: absolute;
    width: 0.16rem;
    height: 0.24rem;
    background-image: url("https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png");
    background-repeat: no-repeat;
    background-size: 20rem 20rem;
    z-index: 2;
    top: 50%;
    margin-top: -0.12rem;
    &.swiper-button-disabled{
        opacity:0;
    }
    &.btn-prev{
        left: -0.24rem;
        background-position:-15.92rem -3.37rem;
    }
    &.btn-next{
        right: -0.24rem;
        background-position: -16.19rem -3.37rem;
    }
}
</style>